export function formatPrice(price: number): string {
  return `$${price % 1 === 0 ? price : price.toFixed(2)}`
}
